import {User} from '../models/user.model';

export class UsersState {
  items: User[];
}
